module.exports = __webpack_public_path__ + "img/belgium-cerebrovascular-disease-female.2ac6c85d.png";